import * as XLSX from 'xlsx'
import { Message } from 'element-ui'
import { importPageField } from '@/api/propertyManage/fixedAssets.js'
import { saveAs } from 'file-saver'
import { fileUpload } from '@/api'
import { isEmpty } from 'lodash-es'
import { updateAttachment } from '@/api/info-security'

const uploadCopyOfFile = async (blob, fileName, logId) => {
  const formData = new FormData()
  formData.append('file', blob, fileName)
  formData.append('code', 'order-data')
  const { code, data: fileData, msg } = await fileUpload(formData)
  if (code === 0 && !isEmpty(fileData)) {
    const { url } = fileData
    if (logId) {
      const params = {
        id: logId,
        attachmentUrl: url
      }
      await updateAttachment(params)
    }
  } else if (msg) {
    // Message.error(msg)
  }
}
const createGlobalLoading = (isShow) => {
  if (isShow) {
    // 创建虚拟 DOM 结构
    // 将虚拟 DOM 插入到文档中
    const loading = document.createElement('div')
    loading.id = 'loading'
    loading.innerHTML = `
    <div class="loader">
	<span class="binary"></span>
	<span class="binary"></span>
	<span class="getting-there">数据导出中，请耐心等待</span>
</div>
        `
    document.body.appendChild(loading)
  }

  if (!isShow) {
    const loading = document.getElementById('loading')
    loading.style.display = 'none'
    // 销毁dom
    document.body.removeChild(loading)
  }
}
export const setWaterMark = (wb, ws) => {
  console.log(wb, ws)
  // 创建水印
  const watermarkText = 'WATERMARK' // 水印文字
  const watermarkColor = '808080' // 灰色
  const watermarkFontSize = 24 // 水印字体大小
  const watermarkOpacity = 0.5 // 透明度

  // 创建水印背景图像
  const drawWatermark = (ctx, x, y, width, height) => {
    ctx.font = `${watermarkFontSize}px Arial`
    ctx.fillStyle = `#${watermarkColor}`
    ctx.globalAlpha = watermarkOpacity
    ctx.translate(x, y)
    ctx.rotate(-Math.PI / 4)
    ctx.fillText(watermarkText, 0, 0)
  }
  // 生成带水印的表格
  const worksheet = wb.Sheets.Data
  const range = XLSX.utils.decode_range(worksheet['!ref'])
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')
  canvas.width = range.e.c * 50 // 50 pixels per column
  canvas.height = range.e.r * 20 // 20 pixels per row
  drawWatermark(ctx, 0, 0, canvas.width, canvas.height)
  const dataURL = canvas.toDataURL()
  worksheet['!background'] = [{ bg: dataURL }]
}
/**
 * ● 导出功能使用的接口为分页查询接口，复用原则，查询条件也同时复用，前端控制好时间间隔来调用接口获取数据
 * ● 通过分页接口获取对应查询参数下的总条数，前端需要自行预估导出数据规模并自动调整数量限制防止把浏览器拉崩溃
 * ● 在确定好数据规模确定能够开始之后，前端需要做好提示和防止误操作，最好给用户明显的进度展示，分页大小不要太大，初始为100，依靠页码和总条数来确定导出进度
 * ● 本地写入表格文件并提示下载
 *
 */

/**
 * @description 前端根据接口生成excel
 * @param {Function} callback 接口的请求方法
 * @param {Object} fetchData 接口的查询参数
 */
export async function exportToExcel(
  callback,
  fetchData,
  urlInfo = '',
  notFields = [],
  config = {}
) {
  try {
    createGlobalLoading(true)
    let data = []
    let total = 0
    fetchData.pageSize = 100
    if (config.custom && config.list) {
      data = config.list
    } else {
      do {
        const response = await callback(fetchData)
        // 此处callback用于复杂数据结构
        config.dataCallback && (response.data = config.dataCallback(response.data))
        if (response.data.records) {
          if (!(response.data.records instanceof Array) || !response.data.records.length) {
            createGlobalLoading(false)
            Message({
              message: '暂无数据',
              type: 'warning'
            })
            return
          }
        } else {
          if (!(response.data instanceof Array) || !response.data.length) {
            createGlobalLoading(false)
            Message({
              message: '暂无数据',
              type: 'warning'
            })
            return
          }
        }
        // 筛选导出需要的字段，notFields是不需要的字段数组，默认为[]，则为全部需要
        if (notFields.length) {
          response.data.records.forEach((it) => {
            notFields.forEach((v) => {
              delete it[v]
            })
          })
        }

        if (response.data.records) {
          data = data.concat(response.data.records)
        } else {
          data = data.concat(response.data)
        }
        total = response.data.total
        fetchData.pageNo++
        fetchData.current++
      } while (data.length < total)
    }
    // 获得对应中文名并替换
    let filedList = {}
    if (config.custom) {
      filedList = {
        data: urlInfo
      }
    } else {
      filedList = await importPageField({
        urlInfo
      })
    }
    if (config.dataHandler) {
      data = config.dataHandler(data)
    }
    const list = []
    let obj = {}
    let sheet
    if (JSON.stringify(filedList.data) !== '{}') {
      for (let i = 0; i < data.length; i++) {
        obj = {}
        if (config.isHeaderSort) {
          // 是否按自定义header排序
          for (const key in filedList.data) {
            for (const key1 in data[i]) {
              if (key === key1) {
                obj[filedList.data[key1]] = data[i][key]
              }
            }
          }
        } else {
          for (const key in data[i]) {
            for (const key1 in filedList.data) {
              if (key === key1) {
                obj[filedList.data[key1]] = data[i][key]
              }
            }
          }
        }
        list.push(obj)
      }
      sheet = XLSX.utils.json_to_sheet(list)
    } else {
      sheet = XLSX.utils.json_to_sheet(data)
    }
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, sheet, 'Data')
    // setWaterMark(workbook, sheet)
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })

    const blob = new Blob([excelBuffer])
    const fileName = (config.customName || new Date().getTime()) + '.xlsx'
    saveAs(blob, fileName)
    createGlobalLoading(false)
    // 是否上传文件副本并传链接给操作日志
    if (config.isUploadCopyOfFile) {
      uploadCopyOfFile(blob, fileName, config.logId)
    }
  } catch (error) {
    createGlobalLoading(false)
  }
}

/**
 * @description 导出支持合并单元格的Excel表格
 * @param {Function} callback 接口的请求方法
 * @param {Object} fetchData 接口的查询参数
 * @param {Object} headers 表头配置，格式为 { field: '中文名称' }
 * @param {Array} excludeColumns 不需要导出的列名数组
 * @param {Object} options 配置选项
 * @param {Boolean} options.needMerge 是否需要合并单元格
 * @param {Array} options.mergeColumns 需要合并的列名数组
 * @param {Boolean} options.autoDetectMerge 是否自动检测需要合并的列
 * @param {Function} options.dataTransformer 数据转换函数，用于对原始数据进行处理
 * @param {Object} options.formatters 格式化配置，格式为 { field: (value, row) => formattedValue }
 */
export async function exportMergeableExcel(
  callback,
  fetchData,
  headers = {},
  excludeColumns = [],
  options = {}
) {
  try {
    createGlobalLoading(true)

    // 默认配置
    const defaultOptions = {
      needMerge: false,
      mergeColumns: [], // 需要合并的列名
      autoDetectMerge: false, // 是否自动检测需要合并的列
      dataTransformer: null, // 数据转换函数
      formatters: {}, // 字段格式化函数集合
      pageSize: 100,
      fileName: new Date().getTime() + '.xlsx'
    }

    const mergeOptions = { ...defaultOptions, ...options }

    // 获取数据
    let data = []
    let total = 0
    const pageParams = { ...fetchData }
    pageParams.pageSize = mergeOptions.pageSize
    pageParams.size = mergeOptions.pageSize

    do {
      const response = await callback(pageParams)
      const records = response.data.records || response.data

      if (!(records instanceof Array) || !records.length) {
        if (data.length === 0) {
          createGlobalLoading(false)
          Message({
            message: '暂无数据',
            type: 'warning'
          })
          return
        }
        break
      }

      // 转换数据
      let processedRecords = records
      if (mergeOptions.dataTransformer && typeof mergeOptions.dataTransformer === 'function') {
        processedRecords = mergeOptions.dataTransformer(records)
      }

      // 删除不需要的字段
      if (excludeColumns.length > 0) {
        processedRecords = processedRecords.map((item) => {
          const newItem = { ...item }
          excludeColumns.forEach((col) => {
            delete newItem[col]
          })
          return newItem
        })
      }

      data = data.concat(processedRecords)
      total = response.data.total || 0

      // 更新页码
      pageParams.pageNo = (pageParams.pageNo || 1) + 1
      pageParams.current = (pageParams.current || 1) + 1
      pageParams.page = (pageParams.page || 1) + 1
    } while (data.length < total)

    // 数据预处理完成后，如果启用了自动检测合并列
    if (mergeOptions.needMerge && mergeOptions.autoDetectMerge) {
      // 这里实现自动检测需要合并的列的逻辑
      mergeOptions.mergeColumns = detectColumnsToMerge(data, headers)
      console.log('自动检测到需要合并的列:', mergeOptions.mergeColumns)
    }

    // 表头转换
    const headersMap = headers

    // 创建工作簿
    const workbook = XLSX.utils.book_new()

    // 先应用数据格式化，然后再处理合并单元格
    // 确保所有数据都经过格式化处理
    console.log('应用格式化前的数据:', JSON.stringify(data.slice(0, 2)))
    console.log('可用的格式化函数:', Object.keys(mergeOptions.formatters))

    const formattedData = data.map((item) => {
      const newItem = { ...item }
      // 应用格式化函数到每个字段
      if (mergeOptions.formatters) {
        Object.keys(mergeOptions.formatters).forEach((field) => {
          if (
            typeof newItem[field] !== 'undefined' &&
            typeof mergeOptions.formatters[field] === 'function'
          ) {
            try {
              const originalValue = newItem[field]
              newItem[field] = mergeOptions.formatters[field](originalValue, newItem)
              // 在第一条记录上打印格式化前后的值
              if (item === data[0]) {
                console.log(`字段 ${field} 格式化: ${originalValue} -> ${newItem[field]}`)
              }
            } catch (error) {
              console.error(`格式化字段 ${field} 出错:`, error)
              // 发生错误时保持原值
            }
          }
        })
      }
      return newItem
    })

    console.log('应用格式化后的数据:', JSON.stringify(formattedData.slice(0, 2)))

    // 将格式化后的数据转换为Excel表格格式
    const excelData = formattedData.map((item) => {
      const newItem = {}
      Object.keys(item).forEach((key) => {
        if (headersMap[key]) {
          // 确保空值处理
          const value = item[key]
          newItem[headersMap[key]] = value === null || value === undefined ? '' : value
        }
      })
      return newItem
    })

    // 创建工作表
    const worksheet = XLSX.utils.json_to_sheet(excelData)

    // 处理合并单元格（如果需要的话）
    if (mergeOptions.needMerge && mergeOptions.mergeColumns.length > 0) {
      // 获取表格范围
      const range = XLSX.utils.decode_range(worksheet['!ref'])

      // 处理合并单元格
      const merges = []
      mergeOptions.mergeColumns.forEach((column) => {
        const headerKey = headersMap[column]
        if (!headerKey) return

        // 在表头中查找该列的索引
        const headerRow = XLSX.utils.sheet_to_json(worksheet, { header: 1 })[0]
        const colIndex = headerRow.findIndex((header) => header === headerKey)

        if (colIndex === -1) return

        // 遍历所有行，查找需要合并的单元格
        let startRow = 1 // 从数据行开始（跳过表头行）
        let prevValue = null

        for (let row = 1; row <= range.e.r; row++) {
          const cellRef = XLSX.utils.encode_cell({ r: row, c: colIndex })
          const currentValue = worksheet[cellRef] ? worksheet[cellRef].v : null

          // 第一行或当前值与前一个值不同
          if (row === 1) {
            prevValue = currentValue
          } else if (currentValue !== prevValue || row === range.e.r) {
            // 需要合并单元格的情况
            if (row - startRow > 1) {
              // 如果是最后一行且值相同，则包含最后一行在内
              const endRow = row === range.e.r && currentValue === prevValue ? row : row - 1
              // 合并从startRow到endRow的单元格
              merges.push({
                s: { r: startRow, c: colIndex },
                e: { r: endRow, c: colIndex }
              })
            }

            startRow = row
            prevValue = currentValue
          }
        }
      })

      // 添加合并信息
      if (merges.length > 0) {
        worksheet['!merges'] = merges
      }
    }

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Data')

    // 导出文件
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
    const blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })
    saveAs(blob, mergeOptions.fileName)

    createGlobalLoading(false)
    return true
  } catch (error) {
    console.error('导出Excel出错:', error)
    createGlobalLoading(false)
    Message({
      message: '导出失败：' + (error.message || '未知错误'),
      type: 'error'
    })
    return false
  }
}

/**
 * 自动检测需要合并的列
 * @param {Array} data 数据数组
 * @param {Object} headers 表头配置
 * @returns {Array} 需要合并的列名数组
 */
function detectColumnsToMerge(data, headers) {
  if (!data || data.length <= 1) return []

  const columnsToMerge = []
  const fields = Object.keys(headers)

  // 对每个字段检查是否存在连续相同值的情况
  fields.forEach((field) => {
    // 跳过不存在于数据中的字段
    if (typeof data[0][field] === 'undefined') return

    let consecutiveSameCount = 0
    let maxConsecutiveSameCount = 0

    // 检查该字段是否有连续相同值的情况
    for (let i = 1; i < data.length; i++) {
      if (data[i][field] === data[i - 1][field]) {
        consecutiveSameCount++
        maxConsecutiveSameCount = Math.max(maxConsecutiveSameCount, consecutiveSameCount)
      } else {
        consecutiveSameCount = 0
      }
    }

    // 如果最大连续相同值数量超过阈值（例如3），则认为该列需要合并
    // 也可以使用百分比来判断，例如相同值占比超过30%
    const mergeThreshold = Math.max(3, Math.floor(data.length * 0.15))
    if (maxConsecutiveSameCount >= mergeThreshold) {
      columnsToMerge.push(field)
    }
  })

  return columnsToMerge
}
